var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"flex column page-layout"},[_c('iframe',{staticClass:"fullscreen-iframe",attrs:{"src":"https://status.casimbagaming.com/ns/elite","seamless":"","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }